import {SearchModalWindow} from './SearchModalWindow';
export default SearchModalWindow;
